import useBindActionCreators from "common/hooks/useBindActionCreators";

import { myFleetOperations } from "../store";

type CarOperations = typeof myFleetOperations;

export const useMyFleetOperations = (): CarOperations => {
  const bindedActions = useBindActionCreators<CarOperations>(myFleetOperations);
  return bindedActions;
};
